import React from 'react';

import { FeedbackModal } from "src/core/common/components/FeedbackModal";
import { FeedbackModalWithRating } from "src/core/common/components/FeedbackModalWithRating";
import { useTranslation } from "src/core/common/hooks/useTranslation";

import type { FeedbackModalVariant } from '../BetaFeatureFeedbackPopover';

type Props = {
  isOpen: boolean;
  feedbackTags: string[];
  className?: string;
  modalVariant?: FeedbackModalVariant;
  analyticsContext?: string;
  onCancel(): void;
  onConfirm(): void;
};

export const BetaFeatureFeedbackModal = ({
  modalVariant = 'default',
  ...rest
}: Props) => {
  const { t } = useTranslation('global');

  switch (modalVariant) {
    case 'withRating':
      return (
        <FeedbackModalWithRating
          {...rest}
          title={t('bookkeep.export.datev.bankJournal.feedback.popoverTitle')}
          confirmText={t(
            'betaFeature.feedbackModal.submitAndSwitchToOldVersion',
          )}
          cancelText={t('betaFeature.feedbackModal.cancel')}
          feedbackLabel={t(
            'bookkeep.export.datev.bankJournal.feedback.feedbackLabel',
          )}
        />
      );
    default:
      return (
        <FeedbackModal
          {...rest}
          title={t('betaFeature.feedbackModal.title')}
          subtitle={t('betaFeature.feedbackModal.subtitle')}
          confirmText={t(
            'betaFeature.feedbackModal.submitAndSwitchToOldVersion',
          )}
          cancelText={t('betaFeature.feedbackModal.cancel')}
          feedbackLabel={t('betaFeature.feedbackModal.textLabel')}
        />
      );
  }
};
